
<template>
    <ListDialog ref="SendPaymentResultDialog" :title="$parent.formatTitle('支払実績表')"  :captions="[]" :widths="[]" :showAdd="false" :showRemove="false" :exec="onReportGenerate" :isRemainAfterExec="true" >
      <template slot="header" slot-scope = "{editor}">
	    <AutoComplete title="帳票テンプレート" :editor="editor" :value.sync="reportTemplate" :required="true" query="SendPaymentResultReportTemplateQuery" tooltip="出力する帳票のテンプレートを選択します。【帳票テンプレート】の【帳票タイプ】が【支払実績表】のデータを選択でき、初期値は×で消してから変更が可能です。" />
	    <AtcSegment title="部門" :editor="editor" :value.sync="segment" tooltip="ここで部門を選択をすると、選択した部門だけのデータを出力する事ができます。選択しない場合はすべての部門のデータが出力できます。" />
        <AtcCounterpart title="取引先" :editor="editor" :value.sync="counterpart" :needsSupplier="true" :needsWarehouse="true" tooltip="ここで取引先を選択をすると、選択した取引先だけのデータを出力する事ができます。選択しない場合はすべての取引先のデータが出力できます。" />
        <AtcBankAccount title="支払口座" :editor="editor" :value.sync="bankAccount" tooltip="ここで支払口座を選択をすると、選択した支払口座だけのデータを出力する事ができます。選択しない場合はすべての支払口座のデータが出力できます。" />
        <Calendar title="支払日(From)" :editor="editor" :value.sync="startDate" :deletable="false" :required="true" :autoEntry="true" :dateFlag.sync="startDateFlag" tooltip="データを帳票に出力をする支払日の開始日を指定します。ここで指定した日付以前のデータは出力対象外となります。" />
	    <Calendar title="支払日(To)" :editor="editor" :value.sync="endDate" :deletable="false" :required="true"  :autoEntry="true" :dateFlag.sync="endDateFlag" tooltip="データを帳票に出力をする支払日の終了日を指定します。ここで指定した日付以降のデータは出力対象外となります。" />
        <RadioButton title="出力形式" :editor="editor" :value.sync="onExcelExport" list="reportStyles"/>                        
      </template>
      <button slot="footer_buttons" type="button" class="btn btn-info" :disabled="$parent.favoriteDisabled" @click="$parent.onShowFavorite">{{$parent.favoriteLoaded? 'お気に入りを更新':'お気に入りに追加'}}</button>
      <button slot="footer_buttons" type="button" class="btn btn-secondary btn_delete" :disabled="$parent.favoriteDisabled" @click="$parent.onDeleteFavorite" v-if="$parent.favoriteLoaded"><i class="material-symbols-outlined small valign">delete</i></button>         
    </ListDialog> 
</template>

<script lang="ts">
import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
import * as Common from '@/tenant/common';
import * as Components from '@/tenant/components';

@Component
export default class RptSendPaymentResult extends Vue {

  // 支払実績表用プロパティ
  public reportTemplate: Common.ReportTemplate = null;
  
  public segment: Common.Segment = null;
  public counterpart: Common.Counterpart = null;
  public bankAccount: Common.BankAccount = null;
  public startDate: Date = null;
  public endDate: Date = null;
  public onExcelExport :boolean = false;
  public startDateFlag : Common.dateFlags = Common.dateFlags.default;
  public endDateFlag : Common.dateFlags = Common.dateFlags.default;  

  public mounted(){
   if ((this.$parent as any).favoriteLoaded == false){         
    var query: Common.SendPaymentResultReportTemplateQuery = new Common.SendPaymentResultReportTemplateQuery();
    this.$api.execute(query).then(obj => {
      var items: Common.ReportTemplate[] = new Array();
      items = (obj as Common.LoadResult).result;
      if (items.length > 0) this.reportTemplate = items[0];
    });
   }
    this.startDate = new Date().getCalendarDate();
    this.endDate = new Date().getCalendarDate();
    (this.$refs.SendPaymentResultDialog as Components.ListDialog).showDialog();
  }
  public async onReportGenerate(){
    var query: Common.SendPaymentResultReportQuery = new Common.SendPaymentResultReportQuery();

    // クエリの設定
    query.templateId = this.reportTemplate.id;
    query.segment = this.segment;
    query.counterpart = this.counterpart;
    query.bankAccount = this.bankAccount;
    query.startDate = this.startDate;
    query.endDate = this.endDate;
    query.onExcelExport = this.onExcelExport;
    
    this.$api.download(query);
  }
}
</script>
